import { Component, OnInit } from '@angular/core';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { AuthenticationResult } from '../models/authentication.model';
import { AuthenticationStatus } from '../enums/enums';
import { AuthBaseComponent } from '../auth-base/auth-base.component';

@Component({
  selector: 'app-auth-customer-service',
  templateUrl: './auth-customer-service.component.html',
  styleUrls: ['./auth-customer-service.component.css']
})
export class AuthCustomerServiceComponent extends AuthBaseComponent implements OnInit {
  public data: any = {};

  ngOnInit(): void {
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2177' })
    .subscribe(res => console.log("sent elasticLog code:2177 - open window", res), error =>console.log("sent elasticLog - open window error!",error));
    this.data = this.modalService.data;
    sessionStorage.setItem("currentWindow", "שירות לקוחות");
    sessionStorage.setItem("elasticCode", "2194");
  }

  submit(form): void {
    const element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element) {
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    if (form.valid) {
      this.pending = true;
      let comeFrom = sessionStorage.getItem("comeFrom");
      //console.log("sent parametes", { CustomerServiceFromScreenId: comeFrom, firstName: form.value.firstName, lastName: form.value.lastName });
      this.authUserService.sendAuthData("CustomerHelp", { CustomerServiceFromScreenId: comeFrom, firstName: form.value.firstName, lastName: form.value.lastName })
        .subscribe((res: AuthenticationResult) => {
          this.modalService.close(res.Details);
        },() => this.pending = false,
          () => this.pending = false
        )
      }
      this.buildFormAccessibility();
  }
}
